export default __webpack_public_path__ + "static/media/tent.97e06243.svg";